import { RedoOutlined, SearchOutlined } from "@ant-design/icons"
import { Button, Card, ConfigProvider, Form, Input, Select, Space } from "antd"
import type React from "react"
import { memo, useEffect } from "react"
import type { ArticleSearchParams } from "@/services/article/articleApi"

interface ArticleSearchFormProps {
  onSearch: (values: Omit<ArticleSearchParams, "page" | "per_page">) => void
  loading?: boolean
  initialValues?: Omit<ArticleSearchParams, "page" | "per_page">
}

const ArticleSearchForm: React.FC<ArticleSearchFormProps> = memo(({ onSearch, loading = false, initialValues }) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues)
    }
  }, [initialValues, form])

  const handleSearch = () => {
    form.validateFields().then((values) => {
      onSearch(values)
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: "",
      type: undefined,
      status: undefined,
    })
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
          },
        },
      }}
    >
      <Card>
        <Form
          form={form}
          initialValues={{
            search: "",
            type: undefined,
            status: undefined,
          }}
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4"
        >
          <Form.Item name="search" label="Từ khóa" colon={false} className="mb-0">
            <Input
              allowClear
              autoComplete="off"
              placeholder="Nhập tiêu đề hoặc nội dung..."
              onPressEnter={handleSearch}
            />
          </Form.Item>

          <Form.Item name="type" label="Loại" colon={false} className="mb-0">
            <Select
              allowClear
              placeholder="Tất cả loại"
              onChange={handleSearch}
              options={[{ label: "Thông báo", value: "notification" }]}
            />
          </Form.Item>

          <Form.Item name="status" label="Trạng thái" colon={false} className="mb-0">
            <Select
              allowClear
              placeholder="Tất cả trạng thái"
              onChange={handleSearch}
              options={[
                { label: "Nháp (Draft)", value: "draft" },
                { label: "Xuất bản (Published)", value: "published" },
              ]}
            />
          </Form.Item>

          <Form.Item label=" " colon={false} className="mb-0">
            <Space>
              <Button type="default" icon={<RedoOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </ConfigProvider>
  )
})

ArticleSearchForm.displayName = "ArticleSearchForm"

export default ArticleSearchForm
